export default {
	data() {
		return {
			filterType: { field: "type", index: null }
		};
	},
	watch: {
		"filterType.index": {
			handler(newVal) {
				let val = this.filterType;
				if (val.index != null && val.index !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.index });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true
		}
	}
};
